import { useNavigate, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import { useAppDispatch } from "../../app/hook";

import {
  ColumnLayout,
  Header,
  Box,
  Button,
  SpaceBetween,
  FormField,
  Input,
  Container,
} from "@cloudscape-design/components-themed";
import { showModal } from "../UI/modal/modal-slice";
import { LABELS } from "./constants";
import { COMMON_LABELS } from "../default-constants";
import { usePutRateUpdateMutation } from "../../features/api";
import { RateUpdate } from "../../features/api-interfaces";
import { isHalfNumberDecimalValid1 } from "../../utils/inputValidation";
import { getMessage } from "../../features/error/messages";

// 料率の入力チェック
export const checkRate = (target: string, paramSetErrorMsg: any) => {
  // 半角数値
  if (!isHalfNumberDecimalValid1(target)) {
    paramSetErrorMsg(getMessage("KGRERR006").label);
    return false;
  }
  paramSetErrorMsg("");
  return true;
};

/*
料率照会・更新画面
 */
export const RateUpdateForm = (props: any) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [putRateUpdate] = usePutRateUpdateMutation();

  let location = useLocation();

  const [rateUpdateErrorMsg, setRateUpdateErrorMsg] = useState("");

  const [checkResultFlag, setCheckResultFlag] = useState(false);

  //入力した内容を詰める
  const [rateUpdateData, setRateUpdateData] = useState({
    rate: "",
    companyCode: location.state.companyCode,
    contractNo: location.state.contractNo,
  } as RateUpdate);

  useEffect(() => {
    setRateUpdateData({ ...rateUpdateData, rate: location.state.rate });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.state]);

  //戻るボタン
  const onClickReturn = () => {
    dispatch(
      showModal({
        title: COMMON_LABELS.TITLES.DL,
        content: COMMON_LABELS.CONTENTS.PAGE_MOVE_CONFIRM,
        positiveBtn: COMMON_LABELS.POSITIVE_BUTTON.OK,
        negativeBtn: COMMON_LABELS.NEGATIVE_BUTTON.CANCEL,
        positiveFn: () => {
          navigate("/merchant/info-inquiry/" + location.state.companyCode);
        },
      })
    );
  };

  // 更新処理
  const feeRateUpdate = () => {
    putRateUpdate(rateUpdateData).then((result: any) => {
      if (!("error" in result) && "error" !== result.data.status) {
        navigate("/merchant/info-inquiry/" + location.state.companyCode);
      }
    });
  };

  // 更新ボタン押下イベント
  const onClickUpdateFormButton = () => {
    if (checkResultFlag) {
      dispatch(
        showModal({
          title: COMMON_LABELS.TITLES.DL,
          content: COMMON_LABELS.CONTENTS.UPDATE_CONFIRM,
          positiveFn: () => {
            feeRateUpdate();
          },
        })
      );
    }
  };

  return (
    <SpaceBetween direction="vertical" size="l">
      <Container header={<Header variant="h2">{LABELS.RATE_TITLE}</Header>}>
        <Container header={<Header variant="h2">{LABELS.FEE_RATE}</Header>}>
          <SpaceBetween direction="horizontal" size="xs">
            <Box variant="p">{LABELS.RATE_INFO}</Box>
          </SpaceBetween>
          <SpaceBetween direction="vertical" size="l">
            <FormField label={LABELS.MERCHANT_NAME} stretch={false}>
              <Input
                onChange={({ detail }) => props.RateUpdate(detail.value)}
                value={
                  location.state.tradeName +
                  COMMON_LABELS.LEFT_PARENTHESIS +
                  location.state.merchantDivisionIdentifier +
                  COMMON_LABELS.RIGHT_PARENTHESIS
                }
                readOnly={props.readOnly}
              />
            </FormField>
            <SpaceBetween direction="horizontal" size="l">
              <FormField label={LABELS.GW} stretch={false}>
                <Input
                  value={location.state.gwCompanyName}
                  onChange={({ detail }) => props.RateUpdate(detail.value)}
                  readOnly={props.readOnly}
                />
              </FormField>
            </SpaceBetween>
            <SpaceBetween direction="horizontal" size="l">
              <FormField
                label={LABELS.FEE_RATE_UPDATE}
                errorText={rateUpdateErrorMsg}
              >
                <Input
                  // value={location.state.rate }
                  onChange={({ detail }) => {
                    setRateUpdateData({
                      ...rateUpdateData,
                      rate: detail.value,
                    });

                    // コールバックチェック関数
                    setCheckResultFlag(
                      checkRate(detail.value, setRateUpdateErrorMsg)
                    );
                  }}
                  value={rateUpdateData.rate}
                  readOnly={false}
                />
              </FormField>
            </SpaceBetween>
          </SpaceBetween>
        </Container>
      </Container>
      <ColumnLayout columns={2}>
        <Box float="left">
          <Button formAction="none" variant="link" onClick={onClickReturn}>
            {COMMON_LABELS.BTNS.BACK}
          </Button>
        </Box>
        <Box float="right">
          <Button onClick={onClickUpdateFormButton} variant="primary">
            {LABELS.RATE_UPDATE}
          </Button>
        </Box>
      </ColumnLayout>
    </SpaceBetween>
  );
};
